const labelCls = "_275lnl28v1";
const chevron = "_275c1b6dm5f";
const linkCls = "_275l5ncv7d";
const stateWrapperCls = "_275sdkgunh";
const iconWrapper = "_275icvo3uw";
const throbberWrapperCls = "_275t17tcejk";
const throbberCls = "_275t1ha8640";

export { chevron, iconWrapper, labelCls, linkCls, stateWrapperCls, throbberCls, throbberWrapperCls };
import "./atom.link.style.linaria.module.css";
//# sourceMappingURL=atom.link.style.js.map
